module.exports = __webpack_public_path__ + "static/media/info-circle.8a28542c.svg";